import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useUser } from '~/providers/user';
import { deleteComment } from '~/redux/reducers/states/comparison_documents';
import { formatTagsToHTML } from '~/utils/formatTaggedUsers';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
export const EmptyComments = () => {
    return (React.createElement("div", { className: 'comment empty' },
        React.createElement("p", null, "There are no comments for this clause yet.")));
};
export const Comment = ({ comment }) => {
    const { taggableComparisonUsers } = useUser();
    const { deletingCommentId } = useSelector((state) => state.comparisonDocumentsState);
    const dispatch = useDispatch();
    const { ref, isComponentVisible: isActionMenuVisible, setIsComponentVisible, } = useComponentVisible(false);
    const handleDeleteComment = (commentId) => {
        dispatch(deleteComment(commentId));
    };
    const formatUsername = (name) => {
        if (name.includes('@')) {
            return name.split('@', 1)[0];
        }
        return name;
    };
    const isDeletingComment = deletingCommentId === comment.id;
    const privilegeGroupNames = comment.privilegeGroups
        ? comment.privilegeGroups.map(privilegeGroup => privilegeGroup.displayName).join(', ')
        : '';
    return (React.createElement("div", { key: comment.date, id: `comment-${comment.id}`, className: 'comment' },
        React.createElement("div", { className: 'title' },
            React.createElement("span", { className: 'author' },
                React.createElement("span", { className: 'name' }, formatUsername(comment.user.name)),
                "\u2022",
                React.createElement("span", { className: 'time' }, getDateFromISOToLocal(comment.date))),
            React.createElement("div", { className: 'right' },
                privilegeGroupNames && (React.createElement("div", { className: 'privilege-groups overflow-ellipsis', title: privilegeGroupNames },
                    React.createElement("div", { className: 'names overflow-ellipsis' }, privilegeGroupNames),
                    React.createElement("div", null,
                        React.createElement("i", { className: 'fas fa-lock icon' })))),
                !isDeletingComment &&
                    React.createElement("span", { className: 'action-dropdown', onClick: () => setIsComponentVisible(!isActionMenuVisible) },
                        React.createElement("i", { className: 'fas fa-ellipsis-v' }),
                        isActionMenuVisible && (React.createElement("div", { ref: ref, className: 'action-list' },
                            React.createElement("div", { className: 'action', onClick: () => handleDeleteComment(comment.id) },
                                React.createElement("i", { className: 'fas fa-trash' }),
                                "\u00A0 Delete Comment")))),
                isDeletingComment && React.createElement("span", null,
                    React.createElement("i", { className: 'fa fa-spinner fa-spin' })))),
        React.createElement("p", { dangerouslySetInnerHTML: {
                __html: formatTagsToHTML(comment.text, taggableComparisonUsers),
            } })));
};
